import {
  DefaultButton,
  DetailsList,
  IColumn,
  PrimaryButton,
  SelectionMode,
  Spinner,
  Stack,
  Text,
  TextField,
} from '@fluentui/react';
import { useEffect, useState } from 'react';

import { store, useAppDispatch } from '../../../App/store';
import { addIcon } from '../../../utils/icons';
import { accountsSearch, useSearch } from '../../../utils/search';
import { accountsSlice, actions } from '../slice';

export default () => {
  const [searchInp, setSearchInp] = useState("");
  const [searchHits, searchLoading, hasSearched, remainingResults] = useSearch(
    accountsSearch,
    searchInp,
    5
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    actions.setSearchQuery(searchInp);
  }, [searchInp, dispatch, accountsSlice.actions]);

  return (
    <Stack tokens={{ childrenGap: 15 }}>
      <Text variant="large">Hesap Seç</Text>
      <TextField
        label="Hesap Adı"
        onChange={(_, nv) => typeof nv === "string" && setSearchInp(nv)}
        value={searchInp}
        autoFocus
      />
      {searchLoading ? (
        <Spinner />
      ) : (
        <>
          {searchHits.length > 0 && (
            <>
              <DetailsList
                items={searchHits}
                columns={columns}
                selectionMode={SelectionMode.none}
                isHeaderVisible={false}
              />
              {remainingResults > 0 && (
                <span>
                  {remainingResults} tane daha gösterilmeyen sonuç var.
                </span>
              )}
            </>
          )}
          {hasSearched && (
            <DefaultButton
              text="Hesap Ekle"
              iconProps={addIcon}
              onClick={promptAddAccount}
            />
          )}
        </>
      )}
    </Stack>
  );
};

const columns: IColumn[] = [
  {
    key: "name",
    minWidth: 16,
    name: "Hesap Adı",
    onRender: (hit) => hit.name,
  },
  {
    key: "phone",
    minWidth: 222,
    name: "Telefon",
    onRender: (hit) => (
      <Stack>
        {hit.phones.map((phone: string, index: number) => (
          <Stack.Item key={index}>{phone.replace("+90 ", "")}</Stack.Item>
        ))}
      </Stack>
    ),
  },
  {
    key: "action",
    minWidth: 96,
    name: "",
    onRender: (hit) => (
      <PrimaryButton onClick={onAccountActionClick} data-id={hit.objectID}>
        Hesap Seç &#x3E;
      </PrimaryButton>
    ),
  },
];
const onAccountActionClick = (event: React.MouseEvent<HTMLElement>) => {
  if (event.target instanceof HTMLElement) {
    let button: HTMLElement;

    if (event.target.tagName === "button") {
      button = event.target;
    } else {
      const closestButton = event.target.closest("button");
      if (!closestButton) return;

      button = closestButton;
    }

    const { id } = button.dataset;

    if (id) {
      store.dispatch(accountsSlice.actions.setActiveAccountId(id));
    }
  }
};
const promptAddAccount = () => {
  actions.reset();
  actions.setPromptAddAccount(true);
};
